module.exports = __webpack_public_path__ + "images/ea9778ad494220253382134f33074172.svg";